// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum IssueStatus {
	New = 1,
	Ongoing = 2,
	Resolved = 3,
}
